import { IconSvg, IconSvgProps } from "./icon"

export default function CheckSquareFill(props: IconSvgProps) {
  return (
    <IconSvg {...props} strokeWidth={0}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6 0A6 6 0 0 0 0 6v12A6 6 0 0 0 6 24h12a6 6 0 0 0 6-6v-12A6 6 0 0 0 18 0h-12Zm12.005 8.947A1.286 1.286 0 0 0 15.994 7.337L9.919 14.938L7.486 13.114a1.286 1.286 0 1 0-1.543 2.057l3.429 2.571a1.286 1.286 0 0 0 1.776-.225l6.857-8.571Z"
        clipRule="evenodd"
      />
    </IconSvg>
  )
}
